import React, { useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { withApollo, compose } from 'react-apollo'
import { useDispatch, useSelector } from 'react-redux'


import {
  message,
  Card,
  Table,
  Divider,
  Popconfirm,
  Button,
  Input,
  Row,
  Col,
  Icon,
  Avatar,
  Tooltip
} from 'antd'

import { useDeepEffect } from '../../utils/hooks'
import _ from 'lodash'
import axios from 'axios'
import Highlighter from 'react-highlight-words'
import { EQUIPMENT_CATEGORY } from '../../utils/constants'
import WrappedEquipmentForm from './components/EquipmentForm'
import {
  getEquipment,
  createEquipment,
  updateEquipment,
  deleteEquipment,
} from '../../modules/equipment'

const Equipment = () => {
  const dispatch = useDispatch()
  let searchInput = useRef(null)
  const [visible, setVisible] = useState(false)
  const [formData, setFormData] = useState({})
  const [searchText, setSearchText] = useState('')
  const [subEquipment, setSubEquipment] = useState([])
  const [seller, setSeller] = useState([])


  const { equipment, isLoading } = useSelector(
    (state) => ({
      equipment: state.equipment.equipment.data,
      isLoading: state.equipment.isLoading
    }),
    []
  )
  useDeepEffect(() => {
    async function fetch() {
      await dispatch(getEquipment())
    }
    fetchSubEquipment()
    fetchSeller()
    fetch()
  }, [])

  async function fetchSubEquipment() {
    try {
      const res = await axios.get(
        process.env.REACT_APP_API_ENDPOINT + `/equipment/subCategory/all`
      )
      setSubEquipment(res.data.data)
    } catch (err) {
      console.log(err)
    }
  }

  async function fetchSeller() {
    try {
      const res = await axios.get(
        process.env.REACT_APP_API_ENDPOINT + `/equipment/seller/all`
      )
      setSeller(res.data.data)
    } catch (err) {
      console.log(err)
    }
  }

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            searchInput = node
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}>
          Search
        </Button>
        <Button
          onClick={() => handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.select())
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  })

  const handleSearch = (selectedKeys, confirm) => {
    confirm()
    setSearchText(selectedKeys[0])
  }

  const handleReset = (clearFilters) => {
    clearFilters()
    setSearchText('')
  }
  const onClick = (e, record) => {
    e.preventDefault()
    setVisible(true)
    setFormData(record)
  }

  const onCloseModal = async () => {
    await setVisible(false)
  }

  const onOk = async (data) => {
    if (!_.isEmpty(formData)) {
      await dispatch(updateEquipment(data))
    } else {
      await dispatch(createEquipment(data))
    }

    await dispatch(getEquipment())
    await setVisible(false)
    await setFormData({})
  }

  const onDelete = async (id) => {
    await dispatch(deleteEquipment(id))
    await dispatch(getEquipment())
  }

  const refetchData = async () => { }

  const columns = [
    {
      title: 'เครื่องจักรอุปกรณ์',
      dataIndex: 'name',
      key: 'name',
      ...getColumnSearchProps('name'),
      onCell: () => {
        return {
          style: {
            whiteSpace: 'nowrap',
            maxWidth: 150,
          }
        }
      },
      render: (name, row) => (
        <Tooltip title={name}>
          <div style={{ textOverflow: 'ellipsis', overflow: 'hidden' }}>
            {row.cover.url && (
              <img
                src={row.cover.url}
                width={64}
                height={64}
                style={{ marginRight: 10, objectFit: 'cover' }}
                alt="Equipment"
              />
            )}
            <Highlighter
              highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
              searchWords={[searchText]}
              autoEscape
              textToHighlight={name.toString()}
            />
          </div>
        </Tooltip>
      )
    },
    {
      title: 'ราคา',
      dataIndex: 'price',
      key: 'price',
      ...getColumnSearchProps('price'),
    },
    {
      title: 'หมวดหมู่',
      dataIndex: 'subEquipment.category.name',
      key: 'category',
      filters: EQUIPMENT_CATEGORY.map(category => ({
        text: category,
        value: category
      })),
      onFilter: (value, record) => record.subEquipment.category.name === value
    },
    {
      title: 'หมวดหมู่ย่อย',
      dataIndex: 'subEquipment.name',
      key: 'subCategory',
      filters: subEquipment.map(subCategory => ({
        text: subCategory.name,
        value: subCategory.name
      })),
      onFilter: (value, record) => record.subEquipment.name === value
    },
    {
      title: 'ผู้ขาย',
      dataIndex: 'seller.name',
      key: 'seller',
      filters: seller.map(seller => ({
        text: seller.name,
        value: seller.name
      })),
      onFilter: (value, record) => record.seller.name === value,
      render: (text, record) => (
        <Row type="flex" gutter={8}>
          <Col>
            <Avatar src={record.seller.logo} size={48} />
          </Col>
          <Col>
            <span style={{ lineHeight: '45px' }}>{text}</span>
          </Col>
        </Row>
      )
    },
    {
      title: 'Action',
      key: 'action',
      width: 100,
      render: (text, record) => (
        <div>
          <Button
            type="primary"
            size="small"
            shape="circle"
            icon="edit"
            onClick={(e) => {
              onClick(e, record)
            }}
          />
          <Divider type="vertical" />
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => onDelete(record.id)}
          >
            <Button
              type="danger"
              size="small"
              shape="circle"
              icon="delete"
            />
          </Popconfirm>
        </div>
      )
    }
  ]
  return (
    <Card
      title="Equipment"
      extra={
        <div>
          <Button size="small" icon="plus" onClick={(e) => onClick(e)}>
            New Equipment
          </Button>
          <Button size="small" icon="reload" onClick={() => refetchData()}>
            Reload
          </Button>
        </div>
      }
    >
      <Table
        loading={isLoading}
        scroll={{ x: 1000 }}
        rowKey={(record) => record.id}
        dataSource={equipment}
        columns={columns}
      />
      <WrappedEquipmentForm
        visible={visible}
        onOk={onOk}
        onCancel={onCloseModal}
        formData={formData}
        seller={seller}
      />
    </Card>
  )
}
export default compose(
  withApollo
)(Equipment)
